import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHorizontalAlignmentTop"><Path d="M3 3V5H21V3H3Z" fill="currentColor"/><Path d="M6 7V21H11V7H6Z" fill="currentColor"/><Path d="M13 7V17H18V7H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHorizontalAlignmentTop;
